import { useCallback, useEffect, useState } from 'react';

import {
  getLastPartidasImport,
  getPartidas,
  getPartidasFilterOptions,
  getPartidasResumen,
} from './partidasService';

const emptyOptions = { productos: [], niveles: [], proveedores: [] };

export default function usePartidas({ filters, page, pageSize, sortField, sortAscending }) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [summary, setSummary] = useState({});
  const [options, setOptions] = useState(emptyOptions);
  const [lastImport, setLastImport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dataError, setDataError] = useState('');
  const [optionsError, setOptionsError] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = useCallback(() => setRefreshKey((value) => value + 1), []);

  useEffect(() => {
    let active = true;
    const loadOptions = async () => {
      setOptionsError('');
      try {
        const [nextOptions, nextImport] = await Promise.all([
          getPartidasFilterOptions(),
          getLastPartidasImport(),
        ]);
        if (!active) return;
        setOptions(nextOptions);
        setLastImport(nextImport);
      } catch (loadError) {
        if (active) setOptionsError(loadError.message);
      }
    };
    loadOptions();
    return () => {
      active = false;
    };
  }, [refreshKey]);

  useEffect(() => {
    let active = true;
    const load = async () => {
      setLoading(true);
      setDataError('');
      try {
        const [result, nextSummary] = await Promise.all([
          getPartidas({ filters, page, pageSize, sortField, sortAscending }),
          getPartidasResumen(filters),
        ]);
        if (!active) return;
        setRows(result.rows);
        setTotal(result.total);
        setSummary(nextSummary);
      } catch (loadError) {
        if (!active) return;
        setRows([]);
        setTotal(0);
        setSummary({});
        setDataError(loadError.message);
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => {
      active = false;
    };
  }, [filters, page, pageSize, sortField, sortAscending, refreshKey]);

  return {
    rows,
    total,
    summary,
    options,
    lastImport,
    loading,
    error: dataError || optionsError,
    dataError,
    refresh,
  };
}
